/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupplierOrganizationMiniDto
 */
export interface SupplierOrganizationMiniDto {
    /**
     * Organization ID
     * @type {number}
     * @memberof SupplierOrganizationMiniDto
     */
    id: number;
    /**
     * Organization name
     * @type {string}
     * @memberof SupplierOrganizationMiniDto
     */
    organizationName: string;
    /**
     * Commercial registration number
     * @type {string}
     * @memberof SupplierOrganizationMiniDto
     */
    commercialNumber: string | null;
    /**
     * Tax identification number
     * @type {string}
     * @memberof SupplierOrganizationMiniDto
     */
    taxNumber: string | null;
    /**
     * Business types array
     * @type {Array<string>}
     * @memberof SupplierOrganizationMiniDto
     */
    businessTypes: Array<SupplierOrganizationMiniDtoBusinessTypesEnum>;
    /**
     * Timestamp organization was created at
     * @type {Date}
     * @memberof SupplierOrganizationMiniDto
     */
    createdAt: Date;
    /**
     * Timestamp organization was updated at
     * @type {Date}
     * @memberof SupplierOrganizationMiniDto
     */
    updatedAt: Date;
    /**
     * Soft delete flag
     * @type {boolean}
     * @memberof SupplierOrganizationMiniDto
     */
    disabled: boolean;
}


/**
 * @export
 */
export const SupplierOrganizationMiniDtoBusinessTypesEnum = {
    Manufacturer: 'MANUFACTURER',
    Importer: 'IMPORTER',
    Distributor: 'DISTRIBUTOR'
} as const;
export type SupplierOrganizationMiniDtoBusinessTypesEnum = typeof SupplierOrganizationMiniDtoBusinessTypesEnum[keyof typeof SupplierOrganizationMiniDtoBusinessTypesEnum];


/**
 * Check if a given object implements the SupplierOrganizationMiniDto interface.
 */
export function instanceOfSupplierOrganizationMiniDto(value: object): value is SupplierOrganizationMiniDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organizationName' in value) || value['organizationName'] === undefined) return false;
    if (!('commercialNumber' in value) || value['commercialNumber'] === undefined) return false;
    if (!('taxNumber' in value) || value['taxNumber'] === undefined) return false;
    if (!('businessTypes' in value) || value['businessTypes'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('disabled' in value) || value['disabled'] === undefined) return false;
    return true;
}

export function SupplierOrganizationMiniDtoFromJSON(json: any): SupplierOrganizationMiniDto {
    return SupplierOrganizationMiniDtoFromJSONTyped(json, false);
}

export function SupplierOrganizationMiniDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierOrganizationMiniDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationName': json['organizationName'],
        'commercialNumber': json['commercialNumber'],
        'taxNumber': json['taxNumber'],
        'businessTypes': json['businessTypes'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'disabled': json['disabled'],
    };
}

export function SupplierOrganizationMiniDtoToJSON(value?: SupplierOrganizationMiniDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'organizationName': value['organizationName'],
        'commercialNumber': value['commercialNumber'],
        'taxNumber': value['taxNumber'],
        'businessTypes': value['businessTypes'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'disabled': value['disabled'],
    };
}

